type State = {
  comments: string;
  in_progress: boolean;
  rating: number | null;
};

type Action =
  | {
      type: "COMMENTS:UPDATE";
      comments: string;
    }
  | {
      type: "IN_PROGRESS:TOGGLE";
      value?: boolean;
    }
  | {
      type: "RATING:UPDATE";
      rating: number | null;
    }
  | {
      type: "RESET";
    };

export function init(state: Partial<State>): State {
  return {
    comments: "",
    in_progress: false,
    rating: null,
  };
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case "COMMENTS:UPDATE":
      return {
        ...state,
        comments: action.comments,
      };
    case "IN_PROGRESS:TOGGLE":
      return {
        ...state,
        in_progress:
          action.value !== undefined ? action.value : !state.in_progress,
      };
    case "RATING:UPDATE":
      return {
        ...state,
        rating: action.rating,
      };
    case "RESET":
      return init({});
    default:
      return state;
  }
}
